import Confirm from './Confirm';
import createConfirmable from './createConfirmable';
import type from './type';


export default Confirm;
export { createConfirmable, type };
